// You can find all the integration types in Console at DataProvider/Modules/Integration/Models/Integrations.php
// or CommonConsole/app/lib/constants.js
export enum IntegrationType {
  INTEGRATION_TYPE_CYRA = 19,
  INTEGRATION_TYPE_PHASR = 17,
}
